import { useState, useEffect } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { gridSpacing } from 'app/constant';
import { deepPurple } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import dayjs from 'dayjs';

const MissionClaims = () => {
    const token = useSelector(selectCurrentToken);

    const [loginUserName, setLoginUserName] = useState('');
    const { data: loginUserNames } = useFetchData('/Customer/LoginUserNames');
    const [clientName, setClientName] = useState('');
    const { data: clientNames } = useFetchData('/Customer/Names');

    const [missionClaims, setMissionClaims] = useState([]);
    const [missionClaimsLoading, setMissionClaimsLoading] = useState(false);
    // const [filterMissionClaimsFrom, setFilterMissionClaimsFrom] = useState(dayjs("2024-01-01").subtract(1, 'days'));
    const [filterMissionClaimsFrom, setFilterMissionClaimsFrom] = useState(dayjs("2024-01-01"));
    const [filterMissionClaimsTo, setFilterMissionClaimsTo] = useState(dayjs("2024-01-01"));
    const [filterCustomerNumberCode, setFilterCustomerNumberCode] = useState('');
    const fetchMissionClaims = async () => {
        if (!filterMissionClaimsFrom.isValid() || !filterMissionClaimsTo.isValid()) {
            warningAlert('Please fill the required fields.');
            return;
        }
        let missionClaimURL = `/MissionClaims/All?createdDateFrom=${filterMissionClaimsFrom.format('YYYY-MM-DD')}&createdDateFromTo=${filterMissionClaimsTo.format('YYYY-MM-DD')}`;
        if (loginUserName !== '') {
            missionClaimURL += `&customerLoginUserName=${loginUserName}`;
        }
        if (filterCustomerNumberCode !== '') {
            missionClaimURL += `&numberCode=${filterCustomerNumberCode}`;
        }
        if (clientName !== '') {
            missionClaimURL += `&clientName=${clientName}`;
        }

        setMissionClaimsLoading(true);
        try {
            const res = await axiosInstance.get(missionClaimURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setMissionClaims(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setMissionClaimsLoading(false);
        }
    };

    useEffect(() => {
        fetchMissionClaims();
    }, []);

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={loginUserName}
                            onChange={(event, newValue) => {
                                setLoginUserName(newValue);
                            }}
                            inputValue={loginUserName}
                            onInputChange={(event, newInputValue) => {
                                setLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={loginUserNames}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={12} lg={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                            gap: '15px',
                            width: '50%',
                            marginLeft: 'auto'
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                float: 'right',
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '20px',
                                marginBottom: '30px'
                            }}
                            onClick={() => fetchMissionClaims()}
                            disabled={missionClaimsLoading}
                        >
                            Filter
                        </Button>
                    </Box>
                </Grid>

                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {missionClaimsLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable missionClaims={missionClaims} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default MissionClaims;
